import { SelectorBase } from '../../Config/SelectorBase';
import { IActivityModel } from './Activity';
import { ActivityThemeSelector } from '../ActivityTheme/ActivityTheme.Selector';
import { ActivityCategorySelector } from '../ActivityCategory/ActivityCategory.Selector';
import getActivityStatus from '../../utils/activityStatusUtils';
import { ICourseCarouselItem } from 'src/components/CourseCarousel';

/* Selector represents the data
 * that needs to be displayed no update or delete should here
 * All of the updates and delete (data changes) should
 * be done via action in the reducer
 */
export class ActivitySelector extends SelectorBase {
  public static getActivities(): IActivityModel[] {
    const session = super.getDataSource();
    const activities = session.Activity.all().toModelArray();
    return activities;
  }
  public static getActivityById(detailKursusId: string): IActivityModel {
    const session = super.getDataSource();
    const activity: IActivityModel = session.Activity.withId(detailKursusId);
    return activity;
  }
  public static getActivitiesByCategoryId(categoryId: number) {
    const session = super.getDataSource();
    const activities: any[] = session.ActivityCategory.withId(
      categoryId.toString()
    )
      .activitycategoryactivitiesSet.all()
      .toRefArray();
    const activityArray: IActivityModel[] = [];
    activities.forEach(act => activityArray.push(act.toActivityId));
    return activityArray;
  }
  public static getActivitiesByFiuNo(fiuNo: string) {
    const session = super.getDataSource();
    const activities: IActivityModel = session.Activity.all()
      .toModelArray()
      .filter(a => a.fiuNo === fiuNo)[0];
    return activities;
  }

  public static getActivitiesWithTitleFromFiuNo(fiuNo: string) {
    return this.getActivities().filter(
      act =>
        act.courseTitle === this.getActivitiesByFiuNo(fiuNo).courseTitle &&
        act.fiuNo !== fiuNo
    );
  }

  public static getActivtiesForSlider(): ICourseCarouselItem[] {
    const activities = this.getActivities();

    const courseSliderItems: ICourseCarouselItem[] = [];
    activities.forEach(a => {
      const status = getActivityStatus(a);
      if (status === 'filteredFromCourseCarousel') {
        return;
      } else if (status === 'lastEnrollmentDatePassed') {
        return;
      }

      if (a.tag !== undefined) {
        // should we count courses?
        courseSliderItems.push({
          status,
          id: a.detailKursusId.toString(),
          description: a.teaserText ? a.teaserText : '',
          startDateTime: a.startDate !== null ? a.startDate.toString() : '',
          endDateTime: a.endDate !== null ? a.endDate.toString() : '',
          signUpForm: a.signUpForm,
          location: a.courseLocation,
          title: a.courseTitle,
          tag: a.tag ? a.tag : {},
          admStatus: a.admStatus,
          isAdvertisement: a.isAdvertisement === true,
          theme: {
            color: 'gray',
            children: ActivityThemeSelector.getThemeById(
              ActivityCategorySelector.getCategoryById(a.categoryId.toString())
                .themeId
            ).name.toString()
          },
          themeImageUrl: ActivityThemeSelector.getThemeById(
            ActivityCategorySelector.getCategoryById(a.categoryId.toString())
              .themeId
          ).themeImageUrl,
          portalPageUrl:
            'kurser/' +
            ActivityCategorySelector.getCategoryById(
              a.categoryId.toString()
            ).themeId.toString() +
            '/' +
            a.categoryId.toString() +
            '/' +
            a.fiuNo
          // {`${this.props.themeId}/${this.props.categoryId}/${a.fiuNo}`}
        });
      }
    });
    return courseSliderItems;
  }
}



// WEBPACK FOOTER //
// ./src/Entities/Activity/Activity.Selector.ts